import { render, staticRenderFns } from "./FrequencyDocumentMobileEdit.vue?vue&type=template&id=770e11bb"
import script from "./FrequencyDocumentMobileEdit.vue?vue&type=script&lang=ts"
export * from "./FrequencyDocumentMobileEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770e11bb')) {
      api.createRecord('770e11bb', component.options)
    } else {
      api.reload('770e11bb', component.options)
    }
    module.hot.accept("./FrequencyDocumentMobileEdit.vue?vue&type=template&id=770e11bb", function () {
      api.rerender('770e11bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencyDocumentMobileEdit.vue"
export default component.exports